import { ErrorBoundary } from '@sentry/react';
import { useSinglePlatformNavigationItems } from '@/hooks/navigation/useSinglePlatformNavigationItems';
import { SideNavLinks } from '../common/SideNavLinks';
import { FallbackSideNavLinks } from '../fallback/FallbackSideNavLinks';

const SinglePlatformSideNavLinksWithData = () => {
  const { primary } = useSinglePlatformNavigationItems();
  return <SideNavLinks navItems={primary} />;
};

export const SinglePlatformSideNavLinks = () => (
  <ErrorBoundary fallback={<FallbackSideNavLinks />}>
    <SinglePlatformSideNavLinksWithData />
  </ErrorBoundary>
);
